const charts = {
    minFontSize: 9,
    maxFontSize: 14
};

export { charts as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhcnRzLmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdGhlbWUvY2hhcnRzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBpbnRlcmZhY2UgQ2hhcnRzIHtcbiAgbWluRm9udFNpemU6IG51bWJlcjtcbiAgbWF4Rm9udFNpemU6IG51bWJlcjtcbn1cblxuY29uc3QgY2hhcnRzOiBDaGFydHMgPSB7XG4gIG1pbkZvbnRTaXplOiA5LFxuICBtYXhGb250U2l6ZTogMTRcbn07XG5cbmV4cG9ydCBkZWZhdWx0IGNoYXJ0cztcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFLQSxNQUFNLE1BQU0sR0FBVztBQUNyQixJQUFBLFdBQVcsRUFBRSxDQUFDO0FBQ2QsSUFBQSxXQUFXLEVBQUUsRUFBRTs7Ozs7In0=
